<p-menu
  #menuRef
  [model]="(menuItems$ | async) ?? []"
  [popup]="true"
  class="menu-primary personal-menu"
>
  <ng-template pTemplate="start">
    @if (profile.state | async; as user) {
      <div class="personal-info">
        <app-avatar
          (click)="menuRef.toggle($event)"
          [photo]="user.photo"
          class="clickable"
          size="40"
        ></app-avatar>

        <div class="info-wrapper">
          <div class="name text-14 fw-600">
            {{ user.name }}

            @if (profile.roleLabelKey$ | async; as roleLabelKey) {
              <div class="counter text-12 fw-600">{{ roleLabelKey | translate }}</div>
            }
          </div>
          <div class="email text-14 fw-400">
            @if (user?.email?.includes('@telematicsalerts.com')) {
              {{ user?.username }}
            } @else {
              {{ user?.email || user?.username }}
            }
          </div>
        </div>
      </div>
    }
  </ng-template>

  <ng-template let-item pTemplate="item">
    <a class="flex align-items-center p-menuitem-link clickable" pRipple>
      <div class="p-menuitem {{ item.cssClass }}">
        @if (item.iconType) {
          <app-dynamic-host
            [componentInputs]="{ color: 'var(--icon-color)', height: 20, width: 20 }"
            [componentType]="item.iconType"
            class="p-menuitem-icon"
          ></app-dynamic-host>
        }

        @if (item.icon) {
          <i [class]="item.icon" class="p-menuitem-icon"></i>
        }

        <span class="p-menuitem-text">{{ item.label }}</span>
      </div>
    </a>
  </ng-template>

  <ng-template pTemplate="end">
    <div class="version-info">
      <span class="text-11 fw-400 color-gray-400">
        {{ 'common.version' | translate }}: {{ version || '---' }}
      </span>
    </div>
  </ng-template>
</p-menu>
